import { CommunityEnum, ExploreAssetTypeEnum, type SelectedAsset, type ViduV1ExploreDetailProReply } from '@/app/types';
import { mergeInspirationInfoAndTaskInfo } from './merge-creation-and-task';

/** 扩展 ExploreDetail 类型，支持活动标记 */
export type ExploreDetailWithActivity = ViduV1ExploreDetailProReply & {
  /** 是否是活动内容 */
  isActivity?: boolean;
};

export const transformExploreDetail = (data: ExploreDetailWithActivity) => {
  const {
    tutorial,
    short_film: shortFilm,
    media_asset: inspiration,
    image_asset: imageAsset,
    mini_video: miniVideo,
    type = 'media_asset',
    isActivity,
    ip_location,
  } = data;
  switch (type) {
    case CommunityEnum.ShortFilm:
      return {
        type: ExploreAssetTypeEnum.ShortFilm,
        value: { ...shortFilm, isActivity, ip_location },
      };
    case CommunityEnum.MediaAsset: {
      const { info, task, activity } = inspiration || {};
      if (!info) {
        throw new Error('info is undefined');
      }
      return {
        type: ExploreAssetTypeEnum.Inspiration,
        value: {
          task,
          info: task ? mergeInspirationInfoAndTaskInfo(info, task) : info,
          isImageAsset: false,
          isActivity,
          ip_location,
          activity,
        },
      };
    }
    case CommunityEnum.ImageAsset: {
      const { info, task, activity } = imageAsset || {};
      if (!info) {
        throw new Error('info is undefined');
      }
      return {
        type: ExploreAssetTypeEnum.Inspiration,
        value: {
          task,
          info: task ? mergeInspirationInfoAndTaskInfo(info, task) : info,
          isImageAsset: true,
          isActivity,
          ip_location,
          activity,
        },
      };
    }
    case CommunityEnum.MiniVideo:
      return {
        type: ExploreAssetTypeEnum.MiniVideo,
        value: { ...miniVideo, isActivity, ip_location },
      };
    case CommunityEnum.Tutorial:
      return {
        type: ExploreAssetTypeEnum.Tutorial,
        value: { ...tutorial, ip_location },
      };
  }
};

export const getAssetInfo = (asset: SelectedAsset) => {
  const { tutorial, shortFilm, inspiration, miniVideo } = asset || {};
  if (shortFilm) {
    return {
      item: shortFilm.info,
      type: CommunityEnum.ShortFilm,
      traceId: shortFilm.traceId,
      id: shortFilm.info?.id,
    };
  }
  if (inspiration) {
    return {
      item: inspiration.info,
      type: CommunityEnum.MediaAsset,
      traceId: inspiration.traceId,
      id: inspiration.info?.id,
    };
  }
  if (tutorial) {
    return {
      item: tutorial.info,
      type: CommunityEnum.Tutorial,
      traceId: tutorial.traceId,
      id: tutorial.info?.id,
    };
  }
  if (miniVideo) {
    return {
      item: miniVideo.info,
      type: CommunityEnum.MiniVideo,
      traceId: miniVideo.traceId,
      id: miniVideo.info?.id,
    };
  }
};
